<template>
  <div class="Site IndexBox" style="padding-top:0">
    <div class="ScrollBox">
      <van-nav-bar
        :border="false"
        :title="$docTitle"
        style="background:transparent"
      >
      </van-nav-bar>
      <div v-if="InitData.betList.length" class="activity-list">
        <a v-for="item,index in InitData.betList" :key="index" @click="openRoom(item)">
          <van-image :src="InitData.setting.up_url+item.cover_img" width="100%" />
          <div class="title">{{item.title}}</div>
          <div v-if="item.description" class="van-multi-ellipsis--l2">{{item.description}}</div>
        </a>
      </div>
      <van-empty v-else :image="`./static/icon/no_data.png`" :description="$t('vanPull[1]')" />
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'Game',
  components: {

  },
  props: [],
  data() {
    return {
      
    }
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    openRoom(data) {
      if(Number(this.$store.state.UserInfo.vip_level)>Number(data.bet_grade)){
        this.$router.push(`/bet/${data.url}`)
      }else{
        if(Number(this.$store.state.UserInfo.balance)<Number(data.bet_balance)){
          this.$Dialog.Confirm(this.$t('Bet[41]',{balance: data.bet_balance}),()=>{
            this.$router.push('/user/recharge')
          })
        }else{
          this.$router.push(`/bet/${data.url}`)
        }
        
      }
    }
  }
}
</script>
<style scoped>
.activity-list{
  padding: 0 15px;
}
.activity-list>a{
  display: block;
  margin: 10px 0 20px;
  overflow: hidden;
  line-height: 1;
}
.activity-list .van-image{
  display: block;
}
.activity-list>a .title{
  padding: 10px 0 6px;
  font-size: 15px;
  font-weight: 600;
}
.activity-list>a .van-multi-ellipsis--l2{
  color: var(--color-assist);
}
</style>